import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppTruckJobMenu } from '../../components/AppTruckJob/AppTruckJob.model';

interface ITruckJobSlice {
	activeMenu: AppTruckJobMenu;
}

const initialState: ITruckJobSlice = {
	activeMenu: AppTruckJobMenu.ALL_ORDERS,
};

const truckJobSlice = createSlice({
	name: 'truckJob',
	initialState,
	reducers: {
		setActiveMenu: (state, action: PayloadAction<AppTruckJobMenu>) => {
			state.activeMenu = action.payload;
		},
		resetTruckJobSlice: () => ({ ...initialState }),
	},
});

export const { setActiveMenu, resetTruckJobSlice } = truckJobSlice.actions;

export default truckJobSlice.reducer;
